import { getDefaultExportFromCjs as e } from "./index61.js";
import { __module as r } from "./index62.js";
import { __require as o } from "./index63.js";
import { __require as t } from "./index64.js";
import { __require as p } from "./index65.js";
if (process.env.NODE_ENV !== "production") {
  var s = o(), i = !0;
  r.exports = t()(s.isElement, i);
} else
  r.exports = p()();
var m = r.exports;
const q = /* @__PURE__ */ e(m);
export {
  q as default
};
